"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BreadCrumbStore_instances, _BreadCrumbStore_breadCrumbs, _BreadCrumbStore_breadCrumbsSubject, _BreadCrumbStore_shallowCopyOfBreadcrumbs, _BreadCrumbStore_topBreadCrumb, _BreadCrumbStore_secondFromTopBreadCrumb, _BreadCrumbStore_emitObservables;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumbStore = void 0;
const rxjs_1 = require("rxjs");
/**
 * Shared state abstraction for breadcrumbs in an MFE application
 */
class BreadCrumbStore {
    /**
     * a BehaviorSubject for the BreadCrumb array
     */
    get breadCrumbsSubject() {
        return __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbsSubject, "f");
    }
    /**
     * construct a new BreadCrumbStore
     */
    constructor() {
        _BreadCrumbStore_instances.add(this);
        _BreadCrumbStore_breadCrumbs.set(this, []);
        _BreadCrumbStore_breadCrumbsSubject.set(this, new rxjs_1.BehaviorSubject(__classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_shallowCopyOfBreadcrumbs).call(this)));
        Object.freeze(this); // enforce js immmutability in addition to ts
    }
    /**
     * Resets the BreadCrumb array to the provided BreadCrumbs
     * @param breadCrumbs The BreadCrumb array with which to set
     */
    set(breadCrumbs) {
        __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length = 0;
        __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").push(...breadCrumbs);
        __classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_emitObservables).call(this);
    }
    /**
     * Empties the BreadCrumb array
     */
    clear() {
        __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length = 0;
        __classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_emitObservables).call(this);
    }
    /**
     * Removes the last BreadCrumb from the array and returns it
     * @returns the last BreadCrumb from the array
     */
    pop() {
        if (__classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length > 0) {
            const topBreadcrumbOrUndefined = __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").pop();
            __classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_emitObservables).call(this);
            return topBreadcrumbOrUndefined;
        }
        return undefined;
    }
    /**
     * adds the specified BreadCrumb to the end of the array and returns the new length of the array
     * @param breadCrumb the BreadCrumb to add
     * @returns the new length of the BreadCrumb array
     */
    push(breadCrumb) {
        __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").push(breadCrumb);
        __classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_emitObservables).call(this);
        return __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length;
    }
    /**
     * Checks the provided BreadCrumb and does one of three things:
     * 1: if the BreadCrumb is the same as the last, does nothing (on same page)
     * 2: if the BreadCrumb is the same as the second to last, removes the last BreadCrumb (back to previous page)
     * 3: otherwise, adds the BreadCrumb to the array
     *
     * @param breadCrumb the BreadCrumb navigation target
     */
    navigate(breadCrumb) {
        const topBreadCrumb = __classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_topBreadCrumb).call(this);
        if (topBreadCrumb && topBreadCrumb.equals(breadCrumb)) {
            return; // on same page, do nothing
        }
        const secondFromTopBreadCrumb = __classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_secondFromTopBreadCrumb).call(this);
        if (secondFromTopBreadCrumb && secondFromTopBreadCrumb.equals(breadCrumb)) {
            this.pop(); // assume they are going back to the previous page
            return;
        }
        this.push(breadCrumb);
        return;
    }
    /**
     * A Typescript type predicate that returns true if the object is a BreadCrumbStore
     * @param object the object to evaluate as a potential BreadCrumbStore
     * @returns true if the object is a BreadCrumbStore
     * @see {@link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates | Using type predicates}
     */
    // a workaround for instanceof not working as expected across MFEs
    static isInstance(object) {
        var _a;
        return object instanceof Object
            && ((_a = object.constructor) === null || _a === void 0 ? void 0 : _a.name) == BreadCrumbStore.name;
    }
}
exports.BreadCrumbStore = BreadCrumbStore;
_BreadCrumbStore_breadCrumbs = new WeakMap(), _BreadCrumbStore_breadCrumbsSubject = new WeakMap(), _BreadCrumbStore_instances = new WeakSet(), _BreadCrumbStore_shallowCopyOfBreadcrumbs = function _BreadCrumbStore_shallowCopyOfBreadcrumbs() {
    return [...__classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f")];
}, _BreadCrumbStore_topBreadCrumb = function _BreadCrumbStore_topBreadCrumb() {
    if (__classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length > 0) {
        return __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f")[__classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length - 1];
    }
    return undefined;
}, _BreadCrumbStore_secondFromTopBreadCrumb = function _BreadCrumbStore_secondFromTopBreadCrumb() {
    if (__classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length >= 2) {
        return __classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f")[__classPrivateFieldGet(this, _BreadCrumbStore_breadCrumbs, "f").length - 2];
    }
    return undefined;
}, _BreadCrumbStore_emitObservables = function _BreadCrumbStore_emitObservables() {
    this.breadCrumbsSubject.next(__classPrivateFieldGet(this, _BreadCrumbStore_instances, "m", _BreadCrumbStore_shallowCopyOfBreadcrumbs).call(this));
};
//# sourceMappingURL=BreadCrumbStore.js.map